import React from "react";
// import Breadcrumb from "../../common/Breadcrumb";
import Breadcrumb from "../../../common/Breadcrumb";
import JoinUs from "../../../common/JoinUs";
import HomeTwoSonsor from "../../home2/HomeTwoSonsor";
import ServiceDetailsWrap from "./ServiceDetailsWrap";
function ServiceDetailsPage() {
  return (
    <>
  <div className="background-image-unset bg-white">
  <Breadcrumb name="Service Details"   />
      <ServiceDetailsWrap  />
         <JoinUs padding="pt-120" />
         <HomeTwoSonsor/>
  </div>

      {/* <JoinUs padding="pt-120" /> */}
      {/* <Sponsor /> */}


    </>
  );
}

export default ServiceDetailsPage;
